import { TooltipProps } from '../tooltips/Tooltip.types';
import { BasePressTooltip } from '../tooltips/base-press-tooltip/BasePressTooltip';
import { BaseButton } from '../buttons/base-button/BaseButton';
import { useCallback } from 'react';
import { BasePressTooltipProps } from '../tooltips/base-press-tooltip/BasePressTooltip.types';

export const Tooltip: React.FC<TooltipProps> = props => {
  const {
    TooltipContent,
    containerStyle,
    backgroundColor,
    width,
    height,
    position,
    onPress,
    tooltipID,
    ...baseButtonProps
  } = props;

  const TooltipButton = useCallback<BasePressTooltipProps['TooltipButton']>(tooltipButtonProps => {
    const { accessible = true, accessibilityLabel, accessibilityRole, ...restBaseButtonProps } = baseButtonProps;

    return (
      <BaseButton
        accessible={accessible}
        accessibilityLabel={accessibilityLabel ?? 'tooltip button'}
        accessibilityRole={accessibilityRole ?? 'button'}
        {...restBaseButtonProps}
        {...tooltipButtonProps}
      />
    );
  }, Object.values(baseButtonProps));

  return (
    <BasePressTooltip
      TooltipContent={TooltipContent}
      containerStyle={containerStyle}
      backgroundColor={backgroundColor}
      width={width}
      height={height}
      position={position}
      onPress={onPress}
      tooltipID={tooltipID}
      TooltipButton={TooltipButton}
      showTooltipArrow
    />
  );
};
